<template>
  <div class="address-window-component">
    <h1 class="step-title font-weight-regular">
      Изменить адрес:
    </h1>
    <div class="button-group d-flex justify-between">
      <v-row dense class="justify-space-between">
        <v-col sm="5">
          <v-btn
            :disabled="isLoading"
            class="button button-back"
            width="100%"
            color="#F1F3F6"
            @click="close"
          >
            <font-awesome-icon icon="chevron-left" />
            Вернуться назад
          </v-btn>
        </v-col>
        <v-col sm="5">
          <v-btn
            :loading="isLoading"
            class="button button-apply"
            width="100%"
            color="#F1F3F6"
            @click="editAddress"
          >
            <font-awesome-icon icon="check" />
            Сохранить адрес
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="street-section">
      <div class="street-field">
        <span class="label">Улица:</span>
        <v-text-field
          v-model="street"
          hide-details="auto"
          class="text-field"
          flat
          solo
          @focus="currentKeyboard = 'street'"
          @blur="setCityFromSearch"
        />
      </div>
      <v-row class="address-inputs">
        <v-col sm="3">
          <span class="label">Дом:</span>
          <v-text-field
            v-model="house"
            hide-details="auto"
            class="text-field"
            flat
            solo
            @focus="currentKeyboard = 'house'"
          />
        </v-col>
        <v-col sm="3">
          <span class="label">Кв/офис:</span>
          <v-text-field
            v-model="apartmentNumber"
            hide-details="auto"
            class="text-field"
            flat
            solo
            @focus="currentKeyboard = 'apartment'"
          />
        </v-col>
        <v-col sm="3">
          <span class="label">Этаж:</span>
          <v-text-field
            v-model="floor"
            hide-details="auto"
            class="text-field"
            flat
            solo
            @focus="currentKeyboard = 'floor'"
          />
        </v-col>
        <v-col sm="3">
          <span class="label">Подъезд:</span>
          <v-text-field
            v-model="entry"
            hide-details="auto"
            class="text-field"
            flat
            solo
            @focus="currentKeyboard = 'entry'"
          />
        </v-col>
      </v-row>
      <v-row class="streets flex-wrap">
        <v-col v-for="(suggest, i) in suggests.slice(0, 4)" :key="i" sm="3">
          <v-btn
            v-if="suggest.street"
            class="button text-normalize"
            width="100%"
            depressed
            @click="setAddressData(suggest)"
          >
            {{ suggest.street }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'

  export default {
    name: 'AddressWindow',
    mixins: [mixinSnackbarMessage],
    props: {
      address: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        isLoading: false,
        addressItems: [],
        showAddressForm: false,
        street: '',
        house: '',
        apartment: '',
        apartmentNumber: '',
        floor: '',
        entry: '',
        timeout: null,
        suggests: [],
        currentAddressId: '',
        currentEditItemId: null,
      }
    },
    watch: {
      street () {
        if (this.street.length > 1) {
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            const params = {
              address: /* 'г Санкт-Петербург ' + */ this.street,
            }
            this.$store
              .dispatch('suggests/fetchAddressSuggestList', params)
              .then((res) => {
                this.suggests = res.data.suggests
              })
          }, 1000)
        }
      },
      basket () {
        this.setDeliveryTab()
      },
    },
    computed: {
      ...mapState({
        basket: state => state.baskets.basket,
        client: state => state.clients.clientsSingle,
        filials: state => state.branches.branches,
      }),
      isSourceYandex () {
        return this.basket.basketSource === 'yandex'
      },
      isSourceDeliveryClub () {
        return this.basket.basketSource === 'deliveryСlub'
      },
    },
    mounted () {
      this.setInitData()
    },
    methods: {
      close () {
        this.$emit('close')
      },
      onClose () {
        this.$emit('onClose')
      },
      setCityFromSearch () {
        if (this.suggests.length === 1) {
          this.city = this.suggests[0].city
        }
      },
      setAddressData (suggest) {
        this.city = suggest.city
        this.street = suggest.street
      },
      editAddress () {
        this.isLoading = true
        const data = {
          city: '', // 'г Санкт-Петербург',
          street: this.street,
          house: this.house,
          apartmentNumber: this.apartmentNumber,
          entry: this.entry,
          floor: this.floor,
        }
        const id = this.address.id
        this.$store
          .dispatch('clients/editAddressClients', { data, id })
          .then((res) => {
            if (res.status === 200) {
              this.showSuccessMessage('Адрес обновлен')
              this.close()
              this.onClose()
            } else {
              this.showErrorMessage(res.response.data.message)
            }
            this.isLoading = false
          })
      },
      setInitData () {
        this.apartmentNumber = this.address.apartmentNumber
        this.city = this.address.city
        this.entry = this.address.entry
        this.floor = this.address.floor
        this.house = this.address.house
        this.street = this.address.street
      },
    },
  }
</script>

<style lang="less" scoped>
.address-window-component {
  padding-top: 30px;
  background-color: #fafafa;

  .filials-section {
    margin-bottom: 24px;
    .label {
      font-size: 24px;
      display: block;
    }
  }

  .tabs {
    margin-bottom: 33px;
    border-bottom: 1px solid #d4d4d4;

    .tab {
      flex: 1;
      outline: none;
      font-size: 24px;
      line-height: 21px;
      border-radius: 14px 14px 0 0;
      height: 57px;

      &.active {
        background-color: #191919;
        font-weight: 900;
        color: @color-primary;
      }
    }
  }

  .step-title {
    font-size: 34px;
    line-height: 21px;
    margin-bottom: 33px;
  }

  .button-group {
    margin-bottom: 21px;

    .button {
      height: 80px;
      font-size: 15px;
      box-shadow: 0 3px 6px #00000029 !important;

      svg {
        margin-right: 8px;
      }
    }

    .button-back {
      border-radius: 10px;
      svg {
        .fill-svg(#0033ff);
      }
    }

    .button-apply {
      background-color: @color-success !important;
      color: #ffffff;
      border-radius: 10px;
      &.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        box-shadow: none !important;
        svg {
          .fill-svg(#00000042);
        }
      }

      svg {
        .fill-svg(#ffffff);
      }
    }
  }

  .address-section {
    margin-bottom: 22px;
  }

  .new-address-section {
    .label {
      display: block;
      font-size: 24px;
      line-height: 21px;
      margin-bottom: 25px;
    }

    .button-add {
      background-color: @color-primary !important;
      height: 94px;

      svg {
        width: 20px;
        height: 20px;
        margin-bottom: 12px;
      }
    }
  }

  .addresses-section {
    .label {
      display: block;
      font-size: 20px;
      line-height: 21px;
      margin-bottom: 31px;
    }
  }

  .text-field {
    &.v-input--is-focused {
      ::v-deep {
        .v-input__slot {
          border: 2px solid #ff9500;
        }
      }
    }

    ::v-deep {
      .v-input__slot {
        height: 80px;
        background-color: @color-secondary;
        border-radius: 15px;

        input {
          font-size: 25px;
          line-height: 18px;
        }
      }
    }
  }

  .street-section {
    .streets {
      min-height: 104px;
    }
    .street-field {
      margin-bottom: 23px;
    }
    .label {
      display: block;
      margin-bottom: 14px;
      font-size: 20px;
      line-height: 21px;
    }

    .button {
      min-height: 80px;
      font-size: 24px;
      line-height: 18px;
      white-space: initial !important;
      background-color: @color-secondary !important;
      ::v-deep {
        .v-btn__content {
          display: block;
          word-break: break-all;
          width: 100%;
        }
      }
    }
  }
}
</style>
